<template>
    <v-container fluid>
        <v-card flat class="px-2">
            <v-card-title class="escalation-matrix d-flex justify-space-between">
              <span>Create Matrix</span>
              <span>
                <v-btn
                  dense
                  elevation="0"
                  small
                  :to="{name: 'matrixList'}"
                >
                    <v-icon small>mdi-chevron-left</v-icon>
                    Back
                </v-btn>
              </span>
            </v-card-title>
            <form @submit.prevent="createMatrixCOnfiguration">
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="4" lg="4" xs="12" sm="4">
                            <v-autocomplete
                                @change="getQueryTypeList"
                                :items="queryRelatedTo"
                                v-model="selectedQueryRelatedToID"
                                dense
                                outlined
                                hide-details
                                item-text="label"
                                item-value="id"
                                required
                            >
                                <template v-slot:label>
                                    queryRelatedTo/Department
                                    <span class="error--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" lg="4" xs="12" sm="4">
                            <v-autocomplete
                                :items="queryType"
                                v-model="selectedQueryTypeId"
                                dense
                                outlined
                                hide-details
                                item-text="label"
                                item-value="id"
                                required
                            >
                                <template v-slot:label>
                                    queryType/ Catergory
                                    <span class="error--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" lg="4" xs="12" sm="4">
                            <v-autocomplete
                                :items="level"
                                v-model="selecetedLevel"
                                dense
                                outlined
                                hide-details
                                item-text="name"
                                item-value="id"
                                required
                            >
                                <template v-slot:label>
                                    Level
                                    <span class="error--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" lg="4" xs="12" sm="4">
                            <v-autocomplete
                                :items="zone"
                                v-model="selectedZone"
                                dense
                                outlined
                                hide-details
                                item-text="name"
                                item-value="id"
                                required
                                return-object
                            >
                                <template v-slot:label>
                                    Zone
                                    <span class="error--text">*</span>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4" lg="8" xs="12" sm="8">
                            <v-text-field
                                v-model="emailId"
                                type="email"
                                dense
                                hide-details
                                outlined
                                required
                            >
                                <template v-slot:label>
                                    Email
                                    <span class="error--text">*</span>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="d-flex justify-end">
                    <v-btn type="submit" color="accent" dense small>Save Matrix</v-btn>
                </v-card-actions>
            </form>
        </v-card>
    </v-container>
</template>
<script>
import CONSTANTS from '@/utils/constants'
export default {
  name: 'createMatrix',
  data () {
    return {
      queryRelatedTo: [],
      queryType: [],
      level: [],
      zone: [],
      selectedQueryRelatedToID: null,
      selectedQueryTypeId: null,
      selecetedLevel: null,
      selectedZone: null,
      emailId: null
    }
  },
  async created () {
    await this.getQueryRelatedList()
    await this.getLevelList()
    await this.getZoneDetails()
  },
  methods: {
    getQueryRelatedList: async function () {
      try {
        let payload = {}
        this.isLoading = true
        let res = await http.post(`${CONSTANTS.API_URL}/api/sbTicketing/getQueryRelatedToList`, payload)
        if (res.status === 200) {
          this.queryRelatedTo = res.data.QueryRelatedTo.data
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        console.log('error in fetching User : ', errorMessage)
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getQueryTypeList: async function () {
      try {
        this.isLoading = true
        let payload = {}
        payload.projectmoduleid = parseInt(this.selectedQueryRelatedToID)
        const res = await http.post(`${CONSTANTS.API_URL}/api/sbTicketing/getQueryTypeList`, payload)
        if (res.status === 200) {
          if (res.data.status) {
            this.queryType = res.data.data
          } else {
            return this.$dialog.error({
              title: 'Error',
              text: res.data.msg
            })
          }
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getLevelList: async function () {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/level/get-levels`)
        if (res.status === 200) {
          if (res.data.level) {
            this.level = res.data.level
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    },
    getZoneDetails: async function () {
      try {
        let res = await http.get(`${CONSTANTS.API_URL}/api/curriculum_cms/get-zones`)
        if (res.data) {
          this.zone = res.data
        }
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    createMatrixCOnfiguration: async function () {
      try {
        if (this.emailId) {
          let reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          if (!this.emailId.match(reg)) {
            this.$dialog.error({
              title: 'Invalid Email',
              text: 'Please enter valid email id.'
            })
            return false
          }
        }
        let payload = {}
        payload.queryRelatedToId = this.selectedQueryRelatedToID
        payload.queryTypeId = this.selectedQueryTypeId
        payload.emailId = this.emailId
        payload.levelId = this.selecetedLevel
        if (this.selectedZone) {
          payload.zoneId = this.selectedZone.id
          payload.zoneName = this.selectedZone.name
        }
        let res = await http.post(`${CONSTANTS.API_URL}/api/sbTicketing/create-user`, payload)
        if (res.status === 200) {
          this.$router.push({ name: 'matrixList' })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    }
  }
}
</script>
